'use strict';

angular.module('amexReconciliationApp')
  .component('transactionHistoryList', {
    templateUrl: 'scripts/views/components/transaction-history-list.html',
    bindings: {
      historyRecords: '<'
    },
    controller: function ($scope,
                          $translate,
                          TransactionsStatusChangeService,
                          TransactionReviewingService,
                          ActiveTransactionModel,
                          TransactionHistoryRepository) {
      var self = this;

      TransactionsStatusChangeService.onTransactionsStatusChanged($scope, fetchHistory);
      TransactionReviewingService.onTransactionReviewed($scope, fetchHistory);

      function fetchHistory() {
        var activeTransaction = ActiveTransactionModel.activeTransaction();
        if(activeTransaction) {
          TransactionHistoryRepository.getTransactionHistory(activeTransaction)
            .then(function(historyRecords) {
              self.historyRecords = historyRecords;
            });
        }
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionHistoryList.js
// module id = 487
// module chunks = 0